import React, { useState } from 'react'
import photoImg from 'assets/images/icon-camera.svg'
import UploadMediaFile from './UploadMediaFile'
import ModalContainer from './ModalContainer'
import { setAvatar } from '../api/profile'

export default function UploadAvatar({ image }) {
  const [showModal, setShowModal] = useState(false)
  const sendFile = async (data) => setAvatar(data)
  const callBack = async () => {
    setShowModal(false)
  }

  return (
    <>
      <button
        type='button'
        className='absolute flex justify-center items-center rounded-[50%] bg-color-green-900 right-0 bottom-0 w-12 h-12 z-10'
        onClick={() => {
          setShowModal(true)
        }}
        id='submit-btn'
      >
        <span className='sr-only'>Cambiar foto</span>
        <img src={photoImg} alt='' />
      </button>
      <ModalContainer
        isShown={showModal}
        setModalFunction={() => setShowModal(false)}
        title='Cambiar avatar'
      >
        <div className='pb-12 w-full'>
          <UploadMediaFile
            title='¿Cómo querés subir tu nuevo avatar?'
            sendFile={sendFile}
            callBack={callBack}
            image={image}
          />
        </div>
      </ModalContainer>
    </>
  )
}
